import { LOCAL_STORAGE_KEYS } from './StorageKeys';

interface userData {
  token?: string;
  deviceId?: string;
  userAgent?: string;
}

export const GLOBAL = {
  SESSION_TOKEN: '',
  DEVICE_ID: '',
  AGENT_ID: '',
  NOTIFICATIONS_POLLING_INTERVAL: 5000,
  NOTIFICATIONS_LONG_POLL: 900000,
  CASE_HISTORY_POLLING_INTERVAL: 3e3,
  CUSTOMER_ID: '',
  SCREEN_WIDTH: 0,
  INNER_WIDTH: window?.innerWidth,
  LONGHORN_SESSION_IDENTIFIER: '',
  AGENT_BUSINESS_VERTICAL: '',
  LONGHORN_BLOCK_STATUS: 'SYNCED'
};

export const setScreenResolution = (width: number) => {
  if (width) {
    GLOBAL.SCREEN_WIDTH = width;
  }
};

export const setCustomerId = (customerId: string) => {
  if (!customerId) return;
  GLOBAL.CUSTOMER_ID = customerId;
};

export const titleString = (count?: number | string) =>
  `${(count && '(' + count + ') ') || ''}Collections - Navi`;

export const setGlobalUserData = (userData: userData) => {
  if (userData?.token) GLOBAL.SESSION_TOKEN = userData.token;
  if (userData?.userAgent) GLOBAL.AGENT_ID = userData.userAgent;
};

export const setGlobalDeviceId = (deviceId: string) => {
  GLOBAL.DEVICE_ID = deviceId ?? '';
};

export const POST_MESSAGE_IDENTIFIER = {
  EXTENSION_ID: 'extensionId',
  PLUGIN_ALIVE: 'pluginAlive',
  ON_WHATSAPP_PLUGIN_INIT: 'ON_WHATSAPP_PLUGIN_INIT',
  SEND_WHATSAPP_CREDENTIALS: 'WHATSAPP_CREDENTIALS',
  AGENT_BREAK_STATUS: 'agentBreakStatus',
  SEND_AGENT_BREAK_STATUS: 'sendAgentBreakStatus',
  RECONFIGURE_CLIENT: 'reconfigureClient',
  LONGHORN_BLOCK_STATUS: 'longhornBlockStatus',
  SLASH_CALL_STATUS_MESSAGE: 'sendMessageToLHFromSlash'
};

export const POST_MESSAGE_PARAMS = {
  EXTENSION_ID_REQ: 'extensionIdReq',
  INITIAL_PORTAL_LOGIN: 'initialPortalnLogin'
};

export const feedbackFormUrl =
  'https://docs.google.com/forms/d/1rzSr3FheX1lr6PM-Rx5uxmBlVRrpG18yqjIzmqNalmc/edit';

export const LITMUS_URL = 'https://longhorn.navi.com/litmus';

export const LONGHORN_URL = 'http://longhorn.navi.com/new/';

export const setLonghornSessionVerifier = (verifier?: string) => {
  if (!verifier) {
    // not storing in LocalStorage since it is creating cyclic dependency issue
    const key = atob(localStorage.getItem(LOCAL_STORAGE_KEYS.LONGHORN_SESSION_IDENTIFIER) || '');
    GLOBAL.LONGHORN_SESSION_IDENTIFIER = key;
    return;
  }
  GLOBAL.LONGHORN_SESSION_IDENTIFIER = verifier;
};

export interface LitmusExperimentResponse {
  result: boolean;
  experiment_name: string;
}

export const SWW_ERROR_MESSAGE = 'Something went wrong!';

export const MAX_FILTERS_AND_SERACHBAR_CONTAINER_WIDTH = 450;

export const APPROX_CHAR_WIDTH = 8;

export const FILTERS_PADDING = 40;

export const MAX_PERFORMANCE = 100;

export const FIREBASE_CONNECTION_LATENCY_THRESHOLD = 5000;

export const NAVIGATION_THRESHOLD_MS = 1000;

export const RESOURCE_TIMING_BUFFER_SIZE = 2000;
export const RESOURCE_TIMING_CLEAR_THRESHOLD = 1500;

export const TOPIC_SEPARATOR = '%7C';

export enum TRUE_OR_FALSE {
  TRUE = 'true',
  FALSE = 'false'
}

export enum GLOBAL_STATUS {
  ONLINE = 'online',
  OFFLINE = 'offline'
}
